import { defineRouting } from "@/i18n/intl-routing";

export const LOCALE_COOKIE_NAME = "APP_LOCALE";
export const LOCALE_OVERRIDE_STORAGE_PREFIX = "APP_LOCALE_OVERRIDE:";

/**
 * Locales the app will RESOLVE. Kinyarwanda stays here on purpose while it is paused: a user whose stored
 * preference or browser says `rw` must still resolve to a real locale rather than falling over, and the
 * message catalogue is complete enough to serve them.
 */
export const routing = defineRouting({
  locales: ["fr", "en", "rw"],
  defaultLocale: "fr",
  localePrefix: "never",
  localeCookie: {
    name: LOCALE_COOKIE_NAME,
    sameSite: "lax",
    path: "/",
  },
  alternateLinks: false,
});

export type AppLocale = (typeof routing.locales)[number];

/**
 * Locales the app OFFERS. Paused, not deleted: Kinyarwanda's catalogue still carries English placeholders in
 * places (the finance investigation timeline, several admin surfaces), and offering a language that falls
 * back to English mid-screen reads as broken rather than as unfinished. Removing it from this list hides the
 * choice; everything else — resolution, storage, the catalogue — is untouched, so re-offering it is one line.
 */
export const OFFERED_LOCALES: readonly AppLocale[] = ["fr", "en"];
